import { HashLink as Link } from "react-router-hash-link";
import Logo from '../assets/cbu/cbutranswisata.png'
import Heroimage from '../assets/cbu/hiace.png'
import Road from '../assets/cbu/road1.png'
import { motion } from "framer-motion"
import { TypeAnimation } from 'react-type-animation'
import "../inc/NavBar"
import "../css/Navbar.css"


function NavHeader () {
  
  
    return (
    
    <section id="home" class="hero">
      <header>

        <Link to="#home"><motion.img src={Logo} alt="montar's logo" id="logoImg" 
      
      initial={{ opacity: 0 }} // Starting state
        whileInView={{ opacity: 1, transition: {delay:0.3, duration:0.6}}} // When the element comes 
        into view
        transition={{ duration: 0.3 }}
        useMotionValueEvent={{y:'100px'}}/></Link>
        <motion.nav
        initial={{ opacity: 0 }} // Starting state
        whileInView={{ opacity: 1, transition: {delay:0.4, duration:0.6}}} // When the element comes 
        into view
        transition={{ duration: 0.3 }}
        useMotionValueEvent={{y:'100px'}}>
          <ul>
            <li>< Link to="#harga" class="fs-6 fw-bold">Harga Sewa Hiace</Link></li>
            <li>< Link to="#kami" class="fs-6 fw-bold">Tentang Kami</Link></li>
            <li>< Link to="#testimonial" class="fs-6 fw-bold">Testimonial</Link></li>
            <li>< Link to="#lokasi" class="fs-6 fw-bold">Lokasi</Link></li>
            <li>< Link to="#footer" class="fs-6 fw-bold">Kontak</Link></li>
    
          </ul>
        </motion.nav>


      </header>
  
    <div class="hero-row">
        <div class="hero-left-col">
          <div class="left-col-text mt-5">
          <motion.p
                initial={{ opacity: 0 }} // Starting state
                whileInView={{ opacity: 1, transition: {delay:0.5, duration:0.6}}} // When the element comes 
                into view
                transition={{ duration: 0.3 }}
                useMotionValueEvent={{y:'100px'}}
              >
          <h2 style={{color: '#2964AE'}}>
   
          <TypeAnimation
                sequence={[
                  
                  300,
                  'Ready! Sewa Hiace!',
                  500,
                  'Ready! harga terjangkau', // initially rendered starting point
                  500,
                  'Termasuk supir & bmm',
                  1000,
                  
                 
                ]}
                wrapper="span"
                speed={150}
                style={{ display: 'inline-block' }}
                repeat={Infinity}
                
              />
                  
          </h2>
            </motion.p>
                <motion.p
                      initial={{ opacity: 0 }} // Starting state
                      whileInView={{ opacity: 1, transition: {delay:0.3, duration:0.6}}} // When the element comes 
                      into view
                      transition={{ duration: 0.3 }}
                    >
              
                  Toyota HiAce memiliki kapasitas 14 penumpang nyaman, baik untuk perjalanan dalam dan luar kota
                  </motion.p>
            </div>
        </div>
        <div class="hero-right-col">
          <motion.img src={Heroimage} alt="illustration"  class="hiaceheader" 
     
          initial={{ opacity: 0 } } // Starting state
          whileInView={{ opacity: 1, transition: {delay:0.7, duration:0.6}}} // When the element comes 
            into view
          transition={{ duration: 0.3 }}
          />
          
                
        </div>
        <motion.img src={Road} alt="illustration"  class="roadheader" 
          initial={{ opacity: 0 }} // Starting state
          whileInView={{ opacity: 1, transition: {delay:0.6, duration:0.6}}} // When the element comes 
          into view
          transition={{ duration: 0.3 }}
          useMotionValueEvent={{y:'100px'}} />
      
       
        
    </div>
    
  </section>

 
  );
}


export default NavHeader;